import "../node_modules/smoothscroll-polyfill/dist/smoothscroll.js";
import * as StickyfillExports from "../node_modules/stickyfilljs/dist/stickyfill.js";
import $ from "./shared/jquery.js";
import "./shared/lazy-image.js";
import "./marathonpetroleum/tabs.js";

// Stickyfill is a CJS, but converted to module by Rollup.
var Stickyfill = window.Stickyfill;

if (!Stickyfill && StickyfillExports.default) {
  Stickyfill = StickyfillExports.default;
}
